import { render } from "./UserViewStatusAccount.vue?vue&type=template&id=d35036f6"
import script from "./UserViewStatusAccount.vue?vue&type=script&lang=js"
export * from "./UserViewStatusAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__